<template>
  <div class="content" v-if="confirmation">
    <div class="wrapper" id="printable" role="log" aria-live="polite">
      <v-btn flat :ripple="false" icon @click="print">
        <v-icon>print</v-icon>
      </v-btn>
      <h1>{{messages.confirmationTitle}}</h1>
      <div class="info-text appointment-details">
        <div class="confirmation-text">{{messages.confirmationText}}</div>
        <div v-if="confirmation.externalId && configuration.showRef">
          <strong>{{messages.commonBookingNumberText}}:</strong>
          {{confirmation.externalId}}
        </div>
        <div v-for="(service, index) in services" :key="index">
          <strong v-if="service.adult">{{ servicesTranslations[service.publicId] && servicesTranslations[service.publicId].names[selectedLanguage.lang] ? servicesTranslations[service.publicId].names[selectedLanguage.lang] : service.name }}: </strong>
          <strong v-else>{{ servicesTranslations[service.publicId] && servicesTranslations[service.publicId].names[selectedLanguage.lang] ? servicesTranslations[service.publicId].names[selectedLanguage.lang] : service.name  }}: </strong>
          <div
            v-if="service.adult || service.child" class="confirmation-service-adult"
          >{{service.adult}} {{messages.chooseServiceContentAdults}}, {{service.child}} {{messages.chooseServiceContentChildren}}</div>
        </div>
        <div>
          <strong>{{messages.commonLocationText}}:</strong>
          {{branchTranslations[confirmation.branch.id] && branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] ? branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] : confirmation.branch.name }}
        </div>
        <div>
          <strong>{{messages.commonDateAndTimeText}}:</strong>
          {{confirmation.date | formatDate(selectedLanguage)}} {{confirmation.time | formatTime(selectedLanguage)}}
        </div>
        <div v-if="confirmation.customer.email" id="confirmationPageEmail">
          <strong>{{messages.Email}}:</strong>
          {{confirmation.customer.email}}
        </div>
        <div v-if="confirmation.customer.phone">
          <strong>{{messages.Phone}}:</strong>
          +{{confirmation.customer.phone}}
        </div>
        <div v-if="checkShowPricesAndServicePrice">
          <strong>{{messages.totalCost}}:</strong>
          {{confirmation.totalCost}} {{messages.chooseServiceContentCurrency}}
        </div>
        <div v-if="checkShowPricesAndCondPrice">
          <strong>{{messages.totalCost}}:</strong>
          {{confirmation.totalCost}} {{messages.chooseServiceContentCurrency}}
        </div>
        <div v-if="configuration.customProperties && configuration.customProperties.enabled">
          <div v-for="(field, index) in customFields" :key="index">
            <strong>{{field.label[selectedLanguage.lang]}}:</strong>
            {{field.selection[selectedLanguage.lang]}}
          </div>
        </div>
        <img :src="qrCodeUrl" alt="Qr code" role="presentation" v-if="configuration.showQR">
      </div>
      <div class="info-text appointment-details dark">
        <h2>{{branchTranslations[confirmation.branch.id] && branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] ? branchTranslations[confirmation.branch.id].names[selectedLanguage.lang] : confirmation.branch.name }}
        </h2>
        <div v-if="confirmation.branch.phone">
          <strong>{{messages.branchPhoneTitle}}:</strong>
          {{confirmation.branch.phone}}
        </div>
        <div v-if="confirmation.branch.email">
          <strong>{{messages.branchEmailTitle}}:</strong>
          {{confirmation.branch.email}}
        </div>
        <div>
          <strong>{{messages.branchAddressTitle}}:</strong>
          {{getBranchAddressBranchCard(confirmation.branch)}}
        </div>
      </div>
    </div>
    <v-btn
      :ripple="false"
      class="submit back"
      flat
      @click="backToStart"
    >{{messages.backToStartPageButtonText}}</v-btn>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { mapState } from 'vuex'
import FormatService from '../services/formatService'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'Confirmation',
  mixins: [ FormatService ],
  props: [
    'confirmation',
    'urlParams',
    'startPage'
  ],
  data: () => ({
    qrCodeUrl: null,
    services: []
  }),
  computed: {
    ...mapState([
      'configuration',
      'servicesTranslations',
      'branchTranslations',
      'messages',
      'selectedLanguage',
      'customFields',
      'funcDebug'
    ]),
    checkShowPricesAndCondPrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'conditionalPrice'
    },
    checkShowPricesAndServicePrice () {
      return this.configuration.pricesEnabled && this.configuration.showPrices && this.configuration.priceCalc === 'servicesPrice'
    }
  },
  methods: {
    backToStart () {
      if (this.funcDebug) console.log('Confirmation:methods:backToStart')
      var _this = this
      // configuration is not used by intention and resolves backend issues

      // clear the store
      this.$store.dispatch('resetBookingStore')
      // check for admin backUrl
      if (this.configuration && this.configuration.backUrl) {
        var url = this.configuration.backUrl ? this.configuration.backUrl : ''
        if (url) {
          location.replace(url)
        } else {
          let routingObj = {
            name: _this.startPage,
            params: _this.urlParams
          }
          eventHub.$emit('reload-configuration', routingObj)
        }
      } else {
        let routingObj = {
          name: _this.startPage,
          params: _this.urlParams
        }
        eventHub.$emit('reload-configuration', routingObj)
      }
    },
    print () {
      window.print()
    }
  },
  mounted () {
    if (this.funcDebug) console.log('Confirmation:mounted')
    var _this = this
    if (!this.confirmation) {
      this.backToStart()
    } else {
      if (this.confirmation.peopleServices.length > 0 && this.confirmation.peopleServices[0].name) {
        this.services = this.confirmation.peopleServices
      } else {
        this.services = this.confirmation.services
      }
      if (this.configuration.showQR) {
        QRCode.toDataURL(this.confirmation.externalId).then(url => {
          _this.qrCodeUrl = url
        })
      }
    }
  }
}
</script>

<style>
@media print {
  .header,
  .submit.back {
    visibility: hidden;
  }
  #printable * {
    visibility: visible;
  }
  .dark {
    background-color: var(--secondary-color) !important;
    color: var(--btn-text-color) !important;
  }
}
</style>
